// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import ContractorRating from '../ContractorRating';
import ContractorCertificatesChecks from '../ContractorCertificatesChecks';
import ContractorPreferedGroupsChecks from '../PreferedGroupsCheck';
import TravelExpenses from './CounterOfferElements/TravelExpenses';
import DateAndTime from './CounterOfferElements/DateAndTime';
import ExplanationInputModal from '../../modal/ExplenationInputModal';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';
import { localCurrencySettings } from '../../../utils/constans';

const InvitedContractorCard = ({
    userType,
    contractorInfo,
    toggleModal,
    setCurrentApplicants,
    currentWorkOrder,
    unRouteWorkOrder,
    acceptInvite,
}) => {
    const [showModal, setShowModal] = useState(false);

    const contractor = contractorInfo.contractor_details || {};
    const workOrderControl = workOrderStatusControl(currentWorkOrder?.status);

    const acceptOnBehalf = (message) => {
        acceptInvite({
            workOrdersId: [currentWorkOrder._id],
            contractorId: contractorInfo.contractor_id,
            historyMessage: message,
        });
    };

    return (
        <div className="card_item">
            <div className="card_body" style={{ display: 'flex', alignItems: 'center' }}>

                <div className="img_card">
                    <img
                        src={contractor.image || 'https://www.w3schools.com/css/img_avatar.png'}
                        alt="Avatar"
                        width="78"
                        height="78"
                    />

                    {contractorInfo.groups?.length ? (
                        <div className="small_img">
                            <ContractorPreferedGroupsChecks />
                            {/* <span>Preferred groups</span> */}
                        </div>
                    ) : null}
                </div>

                <div className="card_main">
                    <div
                        className="card_title"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setCurrentApplicants(contractorInfo);
                            toggleModal(true, 'contractorDetailsModal', true, {
                                contractorId: contractor.userId,
                            });
                        }}
                    >
                        {contractorInfo.contractor_name}
                    </div>

                    <div className="card_title">{`ID - ${contractor.unique_id}`}</div>

                    <div className="card_address">{contractor.address}</div>
                    <div className="card_address">
                        {(contractor.city?.label ? contractor.city.label + ', ' : '') +
                            (contractor.state?.label ? contractor.state.label + ', ' : '') +
                            (contractor.zipcode || '')}
                    </div>

                    {contractorInfo.comment && (
                        <div className="card_address">
                            Comment - {contractorInfo.comment}
                        </div>
                    )}

                    <div className="card_contacts" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div><a href={`tel:${contractor.phone}`}>{contractor.phone}</a></div>
                        <div><a href={`mailto:${contractor.email}`}>{contractor.email}</a></div>
                        {contractor.distance ? (
                            <span>Distance - {contractor.distance.toFixed(2)} Miles</span>
                        ) : null}
                    </div>

                    <div className="card_address">
                        Base Pay:{' '}
                        {(+currentWorkOrder.amount).toLocaleString('en-US', localCurrencySettings)}
                    </div>
                    <div className="card_address">
                        Variable Pay:{' '}
                        {(+currentWorkOrder.variableAmount || 0).toLocaleString(
                            'en-US',
                            localCurrencySettings
                        )}
                    </div>

                    <DateAndTime
                        startDate={contractorInfo.startDate}
                        startTime={contractorInfo.startTime}
                    />

                    <TravelExpenses
                        amount={contractorInfo.amountExpense}
                        description={contractorInfo.descriptionExpense}
                    />
                </div>

                <div className="check_info">
                    <ContractorCertificatesChecks certificates={contractor.certificates} />
                </div>

                <div className="card_side_section">
                    <div className="card_statuses">
                        <ContractorRating contractor={contractor} />
                    </div>

                    <div className="card_actions">
                        {workOrderControl.beforeAssigned && userType === 'client' && (
                            <>
                                {Object.values(contractorInfo.block).some((el) => el) ? (
                                    <button
                                        type="button"
                                        className="standard_btn danger_btn"
                                        onClick={() =>
                                            toggleModal(true, 'blockModal', false, {
                                                contractorId: contractorInfo.contractor_id,
                                            })
                                        }
                                    >
                                        Blocked
                                    </button>
                                ) : (
                                    <button type="button" className="standard_btn danger_btn">
                                        Routed
                                    </button>
                                )}

                                <button
                                    type="button"
                                    className="standard_btn light_btn"
                                    onClick={() =>
                                        unRouteWorkOrder(currentWorkOrder._id, contractorInfo.contractor_id)
                                    }
                                >
                                    Un-Route
                                </button>

                                <button
                                    type="button"
                                    className="standard_btn light_btn"
                                    onClick={() => setShowModal(true)}
                                >
                                    Accept On Behalf
                                </button>

                                <ExplanationInputModal
                                    title="Assignment Comments"
                                    warningMessage="Please enter valid reason"
                                    isCloseAvailable
                                    useOutOfState
                                    isOpen={showModal}
                                    changeIsOpen={setShowModal}
                                    returnExplanation={acceptOnBehalf}
                                />
                            </>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default InvitedContractorCard;